import * as React from "react";
import ListItemButton from "@mui/material/ListItemButton";
import ListItemIcon from "@mui/material/ListItemIcon";
import ListItemText from "@mui/material/ListItemText";
import DashboardIcon from "@mui/icons-material/Dashboard";
import LocalAtmIcon from "@mui/icons-material/LocalAtm";
import ShoppingCartIcon from "@mui/icons-material/ShoppingCart";
import PeopleIcon from "@mui/icons-material/People";
import SettingsIcon from "@mui/icons-material/Settings";
import PendingActionsIcon from "@mui/icons-material/PendingActions";
import { useLocation, useNavigate } from "react-router-dom";
import { RoutePaths } from "../constants";
import Authenticated from "src/core/authenticated";

const navItems = [
  {
    label: "Dashboard",
    link: "/",
    icon: <DashboardIcon />,
    authenticatedRole: ["Admin", "CSR"],
  },
  {
    label: "Reports",
    link: RoutePaths.FINANCIAL_REPORT,
    icon: <LocalAtmIcon />,
    authenticatedRole: ["Admin"],
  },
  {
    label: "Orders",
    link: RoutePaths.ORDER_LISTING,
    icon: <ShoppingCartIcon />,
    authenticatedRole: ["Admin", "CSR"],
  },
  {
    label: "Customers",
    link: RoutePaths.SEARCH_CUSTOMER,
    icon: <PeopleIcon />,
    authenticatedRole: ["Admin", "CSR"],
  },
  {
    label: "Users",
    link: RoutePaths.USER_LISTING,
    icon: <PeopleIcon />,
    authenticatedRole: ["Admin"],
  },
  {
    label: "Complaints",
    link: RoutePaths.COMPLAINT_LISTING,
    icon: <PendingActionsIcon />,
    authenticatedRole: ["Admin", "CSR"],
  },
  {
    label: "Configurations",
    link: RoutePaths.CONFIGURATION,
    icon: <SettingsIcon />,
    authenticatedRole: ["Admin"],
  },
  {
    label: "Leads",
    link: RoutePaths.LEAD_LISTING,
    icon: <SettingsIcon />,
    authenticatedRole: ["Admin", "CSR"],
  },
];

export const DrawerNavigationList = () => {
  const navigate = useNavigate();
  const { pathname } = useLocation();

  return (
      <React.Fragment>
        {navItems.map((item, index) => (
          <Authenticated
            key={index}
            authenticatedRoles={item.authenticatedRole}
          >
            <ListItemButton
              key={item.label}
              selected={pathname === item.link}
              onClick={() => {
                navigate(item.link);
              }}
              sx={{
                "&.Mui-selected": {
                  color: "white",
                  backgroundColor: "#10b9b2",
                  textWrap: "wrap",
                  ":hover": {
                    backgroundColor: "#87d9d6",
                  },
                },
              }}
            >
              <ListItemIcon
                sx={{ color: pathname === item.link ? "white" : "" }}
              >
                {item.icon}
              </ListItemIcon>
              <ListItemText primary={item.label} />
            </ListItemButton>
          </Authenticated>
        ))}
        {/* Timesheet Listing  */}
      </React.Fragment>
  );
};
